import { init } from '@garner-health/lib-ui-real-user-monitoring';
import constants from 'app-constants';

import logger from '~/logging';

const log = logger(__filename);

/**
 * Initializes Datadog RUM + Logs via the shared `@garner-health/lib-ui-real-user-monitoring`
 * wrapper (same integration ui-member uses).
 *
 * The wrapper enables Session Replay at full sample rate with `defaultPrivacyLevel: 'mask'`, so
 * all text and inputs are masked. Errors logged through the app logger are forwarded to RUM by the
 * logs bridge in `~/logging`.
 *
 * No-ops when Datadog credentials are absent (e.g. local dev before the RUM application is
 * provisioned) so the app runs cleanly without a configured RUM application.
 */
export function initDatadog(): void {
  const { applicationId, clientToken } = constants.datadog;

  if (!applicationId || !clientToken) {
    log.warn('Datadog RUM credentials not configured; skipping RUM initialization');
    return;
  }

  try {
    init({
      config: { applicationId, clientToken },
      service: 'ui-datapro',
      environment: constants.env,
      version: GARNER_VERSION,
      site: 'datadoghq.com',
      distribution: 'web',
      allowedTracingUrl: constants.fullApiBaseUrl,
      enableExperimentalFeatures: ['feature_flags'],
      logger: log,
    });
  } catch (err) {
    log.error({ err }, 'Failed to initialize Datadog RUM');
  }
}
